import Lenis, { gsap, ScrollTrigger } from '../vendor/vendor-globals.js';

const scrollListeners = new Set();

export function onLenisScroll(listener) {
  scrollListeners.add(listener);

  return () => {
    scrollListeners.delete(listener);
  };
}

function notifyScrollListeners(data) {
  scrollListeners.forEach((listener) => {
    listener(data);
  });
}

export function initLenis() {
  if (typeof Lenis !== 'function') {
    return () => {};
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return () => {};
  }

  if (window.matchMedia('(max-width: 767px)').matches) {
    return () => {};
  }

  const root = document.documentElement;
  let lenis = null;
  let observer = null;
  let tickerFn = null;

  const start = () => {
    if (lenis) {
      return;
    }

    const useGsap = Boolean(gsap && ScrollTrigger);

    lenis = new Lenis({
      anchors: true,
      autoRaf: !useGsap,
    });

    lenis.on('scroll', (data) => {
      if (useGsap && ScrollTrigger) {
        ScrollTrigger.update();
      }

      notifyScrollListeners(data);
    });

    if (!useGsap) {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    tickerFn = (time) => {
      lenis.raf(time * 1000);
    };

    gsap.ticker.add(tickerFn);
    gsap.ticker.lagSmoothing(0);
    ScrollTrigger.refresh();
  };

  if (root.getAttribute('data-loader') === 'active') {
    observer = new MutationObserver(() => {
      if (root.getAttribute('data-loader') !== 'active') {
        observer.disconnect();
        observer = null;
        start();
      }
    });
    observer.observe(root, { attributes: true, attributeFilter: ['data-loader'] });
  } else {
    start();
  }

  return () => {
    observer?.disconnect();
    if (tickerFn && gsap) {
      gsap.ticker.remove(tickerFn);
    }
    lenis?.destroy();
    lenis = null;
  };
}
